import {IW_MODULES, IW_VIDEOS, IW_STATUS} from './../actions/ActionTypes';
import InitialState from './InitialState';
import {setUser, getUser} from '../utils/TokenManager';

const IWReducer = (state = InitialState.iwData, action) => {
    switch (action.type) {
        case IW_MODULES: {
            return {
                ...state,
                modules: action.modules
            };
        }

        case IW_VIDEOS: {
            return {
                ...state,
                videos: action.videos
            };
        }

        case IW_STATUS: {
            let user = getUser();
            let updateduser = {...user, "is_installation_completed": action.status}
            setUser(updateduser);
            window.location.reload(true);
            return {...state}
        }

        default:
            return state;
    }
};

export default IWReducer;



// WEBPACK FOOTER //
// ./src/reducers/InstallationWizardReducer.js